/**
 * @author Adam Vlasek <adam.vlasek@styrax.cz>
 */

import React, { createContext, useState, useEffect } from 'react';
import request from 'axios';

import StringAssociativeArrayInterface from '../../types/StringAssociativeArrayInterface';

const ConfigContext = createContext({});

declare global {
    interface Window {
        config: any
    }
}

type ConfigProps = {
    children: () => JSX.Element
}

const Config = ({ children }: ConfigProps) => {
    const [state, setState] = useState({
        config: {},
        error: false,
        loaded: false
    });

    useEffect(
        () => {
            let config: StringAssociativeArrayInterface<any> = {};

            const errorHandler = (e: any) => {
                console.error(e);
                setState({
                    config: config,
                    error: true,
                    loaded: true
                });
            };

            const successHandler = (data: any) => {
                config = { ...config, ...data };
                window.config = config;
                document.title = config.name;

                setState({
                    config: config,
                    error: false,
                    loaded: true
                });
            };

            request
                .get('config.json')
                .then(({ data }) => successHandler(data))
                .catch(errorHandler);
        },
        []
    );

    if (!state.loaded) return null;

    return (
        <ConfigContext.Provider value={state.config}>
            {
                state.error ?
                    <p>Nepodařilo se načíst konfigurační soubor.</p> :
                    state.loaded && children()
            }
        </ConfigContext.Provider>
    );
};

export default Config;
export const consumer = ConfigContext.Consumer;
